import { ReactNode } from 'react';

import { Box, List, SxProps, Theme } from '@mui/material';

import { Dimens } from '~themes';

/** An `<li>` wrapper that carries no list bullet and stretches full width. */
export const MenuLi = ({ block = false, children }: { block?: boolean; children: ReactNode }) => (
	<Box
		component='li'
		sx={{
			width: '100%',
			listStyle: 'none',
			display: 'flex',
			flexDirection: block ? 'column' : 'row',
			alignItems: 'center',
			justifyContent: 'center',
		}}
	>
		{children}
	</Box>
);

/** A nested `<ul>` for a section's / dropdown's children. */
export const MenuSubList = ({
	children,
	sx,
}: {
	children: ReactNode;
	paddingTop?: string | number;
	sx?: SxProps<Theme>;
}) => (
	<List
		disablePadding
		sx={[
			{
				display: 'flex',
				flexDirection: 'column',
				gap: { xs: Dimens.spacingXs, md: Dimens.spacingNone, xl: Dimens.spacingXs },
				width: '100%',
			},
			...(Array.isArray(sx) ? sx : [sx]),
		]}
	>
		{children}
	</List>
);
